export const Limits = {
  CAMPAIGNS: 'campaigns'
};
export const Scopes = {
  CAMPAIGNS: 'campaigns-access',
  CAMPAIGNS_WRITE: 'campaigns-write',
  CRM_EXPORT: 'crm-export',
  REVENUE_ATTRIBUTION_READ: 'revenue-attribution-read',
  REVENUE_ATTRIBUTION_LITE: 'revenue-attribution-lite',
  SOCIAL_ALL_ACCOUNTS_CONFIGURE: 'social-all-accounts-configure',
  SOCIAL_SHARED_ACCOUNTS_PUBLISH: 'social-shared-accounts-publish',
  SOCIAL_OWNED_ACCOUNTS_PUBLISH: 'social-owned-accounts-publish',
  SOCIAL_DRAFT_ONLY_USER_ACCESS: 'social-draft-only-user-access',
  CAMPAIGNS_REVENUE_PRO: 'campaigns-revenue-pro',
  CUSTOM_ASSOCIATION_LABELS_WRITE: 'custom-association-labels-write'
};